var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions,"duplicateCheck":true},on:{"vdropzone-success":_vm.fileUploadSuccess,"vdropzone-removed-file":_vm.fileRemoved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }